// @flow
import * as React from 'react';
import Screen from '../../Components/Screen';

import Breadcrumbs from './Components/Breadcrumbs';
import Header from './Components/Header';
import Filters from './Components/Filters';
import Table from './Components/Table';

import SupplierModal from '../../Modals/Supplier'

type Props = {
  suppliers: [],
  pagination: {},
  fetching: boolean,
  showSupplierModal: boolean,
  searchTerm: string,
  filters: any,

  componentDidMount: () => void,
  onChangeTable: () => void,
  onChangeFilter: () => void,
  onClickNewSupplier: () => void,
  onCloseSupplierModal: () => void,
  didCreateSupplier: () => void,
  didDeleteSupplier: () => void,
  onChangeSearch: () => void,
  onSubmitSearch: () => void,
}

export default class extends React.PureComponent<Props> {

  componentDidMount = () => this.props.componentDidMount();

  render() {

    const {
      suppliers,
      pagination,
      fetching,
      showSupplierModal,
      searchTerm,
      filters,

      onChangeTable,
      onClickNewSupplier,
      onCloseSupplierModal,
      didCreateSupplier,
      didDeleteSupplier,
      onChangeSearch,
      onSubmitSearch,
      onChangeFilter
    } = this.props;

    return (

      <Screen>

        <Breadcrumbs />

        <Header
          searchTerm={searchTerm}
          onChangeSearch={onChangeSearch}
          onSubmitSearch={onSubmitSearch}
          onClickNewSupplier={onClickNewSupplier}
        />

        <Filters
          filters={filters}
          onChangeFilter={onChangeFilter}
        />

        <Table
          suppliers={suppliers}
          fetching={fetching}
          pagination={pagination}
          onChangeTable={onChangeTable}
        />

        {showSupplierModal && (
          <SupplierModal
            onClose={onCloseSupplierModal}
            didCreate={didCreateSupplier}
            didDelete={didDeleteSupplier}
          />
        )}
      </Screen>

    )
  }
}
